/*
 * SMSComplianceNotice — 10DLC-required consent/opt-out disclosure.
 * Shown as small-print on ANY form that collects a phone number for
 * transactional SMS (rider phone, driver phone, TP contact, broadcast).
 *
 * Copy is intentionally short and links to the full public /sms-terms page.
 * Support contact is env-driven so it's easy to change without a redeploy.
 */
import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";

const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE || "+1 (313) 685-8353";
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "dispatch@medexova.com";
const BRAND = "MedexOVA Transportation";

export default function SMSComplianceNotice({ compact = false, className = "" }) {
  if (compact) {
    return (
      <p className={`text-[10px] leading-snug text-slate-500 ${className}`} data-testid="sms-compliance-compact">
        By providing a phone number you consent to receive SMS from {BRAND} about the trip.
        Msg &amp; data rates may apply. Reply <b>STOP</b> to opt out, <b>HELP</b> for help.
        {" "}<Link to="/sms-terms" className="underline">Terms</Link>.
      </p>
    );
  }
  return (
    <div className={`mt-3 rounded-md border border-slate-200 bg-slate-50 p-3 ${className}`} data-testid="sms-compliance-notice">
      <div className="flex items-start gap-2">
        <MessageSquare size={13} className="mt-0.5 text-slate-500 shrink-0" />
        <div className="text-[10.5px] leading-relaxed text-slate-600">
          <b>SMS notifications:</b> By providing a phone number you agree to receive transactional SMS
          from <b>{BRAND}</b> (trip confirmations, driver-arrival updates, dispatch links).
          Message frequency varies. <b>Msg &amp; data rates may apply.</b>
          {" "}Reply <b>STOP</b> to unsubscribe at any time, or <b>HELP</b> for help.
          {" "}Carriers not liable for delayed or undelivered messages.
          Questions? Text or call <a href={`tel:${SUPPORT_PHONE.replace(/\s|\(|\)|-/g,"")}`} className="underline">{SUPPORT_PHONE}</a>
          {" "}or email <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">{SUPPORT_EMAIL}</a>.
          {" "}See our full <Link to="/sms-terms" className="underline">SMS Terms</Link> and{" "}
          <Link to="/privacy" className="underline">Privacy Policy</Link>.
        </div>
      </div>
    </div>
  );
}
